import { LoadingButton } from '@mui/lab';
import { Box, Card, Container, Typography } from '@mui/material';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import Header from 'src/layouts/dashboard/header/header.component';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import NobrandIcon from '../../assets/icons/no-brnd-org.svg';
import CreateBrand from './createBrand.component';

const NoBrand = () => {
  const { t: translate } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);
  const { showToast } = useToaster();
  const navigate = useNavigate();

  const activeBrandId = CommonHelper.GetCurrentBrandId();

  if (activeBrandId) {
    window.location.href = window.location.origin;
  }

  const isOrgUser = CommonHelper.GetBrandInfoFromLocalStorage('is_org_user');
  const isCustomDomain = CommonHelper.CustomDomain();

  // State Variables
  const [isLeaveOrgLoading, setLeaveOrgLoader] = useState(false);
  const [isDeleteOrgLoading, setDeleteOrgLoader] = useState(false);

  const leaveOrgSuccessCallback = (data, message) => {
    message && showToast(message, 's');
    navigate('/no-organization');
  };

  const failureCallback = (message) => {
    message && showToast(message, 'e');
    setLeaveOrgLoader(false);
    setDeleteOrgLoader(false);
  };

  const handleLeaveOrganization = () => {
    setLeaveOrgLoader(true);
    CommonHelper.LeaveOrganization(leaveOrgSuccessCallback, failureCallback);
  };

  const handleDeleteOrganization = () => {
    setDeleteOrgLoader(true);
    CommonHelper.DeleteOrganization(leaveOrgSuccessCallback, failureCallback);
  };

  const handleOpenConfirm = (action) => {
    setCurrentAction(action);
    setConfirmOpen(true);
  };

  const handleCloseConfirm = () => {
    setConfirmOpen(false);
    setCurrentAction(null);
  };
  const handleConfirmAction = () => {
    if (currentAction === 'delete') {
      handleDeleteOrganization();
    } else if (currentAction === 'remove') {
      handleLeaveOrganization();
    }
    handleCloseConfirm();
  };

  return (
    <>
      <Helmet>
        <title>{translate('brand.no_brand')}</title>
      </Helmet>
      <Header headerName={''} />
      <Container>
        <div
          style={{
            display: 'flex',
            minHeight: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 10,
          }}
        >
          <Container>
            <Box sx={{ maxWidth: 680, mx: 'auto' }}>
              <Card sx={{ py: 3, px: 3, textAlign: 'center' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <img src={NobrandIcon} style={{ height: 300 }} />
                </Box>
                <Typography variant="h3" paragraph>
                  {translate('brand.not_associated_with_any_brand')}
                </Typography>
                <Typography sx={{ color: 'text.secondary', mb: 3 }}>{translate('brand.contact_admin')}</Typography>
                {isOrgUser && (
                  <>
                    <CreateBrand />
                    <LoadingButton
                      variant="contained"
                      size="large"
                      fullWidth
                      style={{ marginBottom: 20 }}
                      loading={isDeleteOrgLoading}
                      onClick={() => {
                        handleOpenConfirm('delete');
                      }}
                    >
                      {translate('brand.delete_organization')}
                    </LoadingButton>
                  </>
                )}
                {!isCustomDomain && (
                  <LoadingButton
                    variant="contained"
                    size="large"
                    fullWidth
                    loading={isLeaveOrgLoading}
                    onClick={() => {
                      handleOpenConfirm('remove');
                    }}
                  >
                    {translate('brand.leave_organization')}
                  </LoadingButton>
                )}
              </Card>
              <ConfirmationDialog
                open={confirmOpen}
                onClose={handleCloseConfirm}
                onConfirm={handleConfirmAction}
                title={
                  currentAction === 'delete'
                    ? translate('common.confirm_deletion')
                    : translate('profile.general.confirm_leave_organization')
                }
                message={
                  currentAction === 'delete'
                    ? `${translate('manage_organization.organization_info.confirm_delete_organization')}. ${translate(
                        'manage_organization.organization_info.this_cannot_undone'
                      )}`
                    : `${translate('manage_organization.organization_info.confirm_leave_organization')}. ${translate(
                        'manage_organization.organization_info.this_cannot_undone'
                      )}`
                }
                submitButtonName={translate('common.yes')}
              />
            </Box>
          </Container>
        </div>
      </Container>
    </>
  );
};
export default NoBrand;
